import { useMemo } from 'react';

// project imports
import { usePermissions } from 'hooks/usePermissions';
import { filterMenuItemsByPermissions } from 'utils/filterMenuItems';
import modules from './modules';

// ==============================|| MENU ITEMS ||============================== //

export default function useMenuItems() {
  const { hasAnyPermission, hasAnyRole } = usePermissions();

  const menuItems = useMemo(() => {
    const allItems = {
      items: [modules]
    };

    return {
      items: filterMenuItemsByPermissions(allItems.items, hasAnyPermission, hasAnyRole)
    };
  }, [hasAnyPermission, hasAnyRole]);

  return menuItems;
}
